<template>
    <div
        :class="[
            styles.table,
            classStyles['divide-main_color-700'],
            { 'divide-y-4 divide-solid divide-opacity-70': content.length > 1 }
        ]"
        class="mb-4 bg-white"
    >
        <div :class="styles.table_first_td"
             class="flex justify-between p-4"
        >
            <h2
                :class="classStyles['text-secondary_color-500']"
                class="self-center text-2xl sm:text-3xl"
            >
                {{ title }}
            </h2>
            <div>
                <slot name="action"></slot>
            </div>
        </div>
        <div
            v-for="(myElement, key) of content"
            :key="key"
        >
            <h3
                v-if="content.length > 1"
                :class="classStyles['text-secondary_color-500']"
                class="text-md p-4 sm:text-xl"
            >
                #{{ key + 1 }}
            </h3>
            <table class="w-full table-fixed border-collapse">

                <tbody class="text-gray-800">
                <tr
                    v-for="(element, index) in myElement"
                    :key="index"
                    :class="[index === myElement.length - 1 ? styles.table_last_tr : styles.table_tr]"
                >
                    <td
                        v-if="myElement.condition === undefined || myElement.condition"
                        :class="[index === Object.keys(content).length - 1 ? styles.table_last_left_td : '']"
                        class="ml-4 p-3"
                        v-text="element.name"
                    ></td>
                    <td
                        v-if="myElement.condition === undefined || myElement.condition"
                        :class="[index === Object.keys(content).length - 1 ? styles.table_last_right_td : '']"
                        class="ml-4 p-3"
                    >
                        <div
                            v-if="element.value"
                            class="overflow-x-auto"
                            v-html="element.value"
                        ></div>
                        <div
                            v-else
                            class="overflow-x-auto"
                        >
                            <slot
                                :index="key"
                                :name="element.slug"
                            ></slot>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
  name: 'BaseTable',
  props: {
    title: String,
    content: Array
  },

  data () {
    return {
      styles: window.myStyles,
      classStyles: window.class_styles
    }
  }
}
</script>

<style scoped>

</style>
